var _path, _path2, _rect, _g, _path3, _path4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBlastConnect = function SvgBlastConnect(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.695 75.1698H0.353516L18.4049 62.5234H123.644L141.695 75.1698Z",
    fill: "url(#paint0_linear_2746_11537)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142 74.9844H0L17.5632 141.984H122.568L142 74.9844Z",
    fill: "url(#paint1_linear_2746_11537)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2746_11537",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 62,
    width: 71,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0605,
    y: 62.5215,
    width: 70.6707,
    height: 12.6463,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2746_11537)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2746_11537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.0234,
    cy: 62.8922,
    rx: 24.5488,
    ry: 4.09146,
    fill: "#160438"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102 13.4909C102 6.10909 96.191 0 88.8989 0H75.3034C74.9326 0 74.5618 0.254545 74.4382 0.509091L69.3708 9.54545L57.2584 31.1818H49.2247C47.7416 31.1818 46.6292 29.9091 46.6292 28.5091C46.6292 27.7455 46.8764 27.2364 47.1236 26.8545L50.8315 21.6364C51.0787 21.2545 51.0787 20.7455 50.8315 20.3636L47 15.1455C46.7528 14.7636 46.5056 14.2545 46.5056 13.4909C46.5056 11.9636 47.7416 10.8182 49.1011 10.8182H57.2584L61.7079 18.7091L67.764 7.89091L63.6854 0.509091C63.4382 0.254545 63.0674 0 62.6966 0H49.1011C41.9326 0 36 6.10909 36 13.4909C36 16.1636 36.7416 18.7091 38.2247 21C36.7416 23.1636 36 25.8364 36 28.5091C36 35.8909 41.9326 42 49.1011 42H62.6966C63.0674 42 63.4382 41.7455 63.5618 41.4909L69 31.8182L80.7416 10.8182H88.7753C90.2584 10.8182 91.3708 12.0909 91.3708 13.4909C91.3708 14.2545 91.1236 14.7636 90.8764 15.1455L87.2921 20.3636C87.0449 20.7455 87.0449 21.2545 87.2921 21.6364L91.1236 26.8545C91.3708 27.2364 91.618 27.7455 91.618 28.5091C91.618 30.0364 90.382 31.1818 89.0225 31.1818H80.8652L76.4157 23.2909L70.3595 34.1091L74.4382 41.4909C74.5618 41.7455 74.9326 42 75.3034 42H88.8989C96.191 42 102 35.8909 102 28.5091C102 25.8364 101.258 23.2909 99.7753 21C101.258 18.8364 102 16.1636 102 13.4909Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0807 134H60.5017C62.1847 134 63.2957 133.219 63.2957 131.899V131.877C63.2957 130.821 62.5587 130.293 61.6457 130.018C62.2507 129.754 62.8667 129.237 62.8667 128.236V128.214C62.8667 127.719 62.6907 127.312 62.3717 126.982C61.9317 126.553 61.2387 126.3 60.3587 126.3H57.0807V134ZM61.9867 128.357C61.9867 129.259 61.2607 129.732 60.2157 129.732H57.9387V127.081H60.2817C61.3817 127.081 61.9867 127.576 61.9867 128.335V128.357ZM62.4157 131.822V131.844C62.4157 132.702 61.6897 133.219 60.5237 133.219H57.9387V130.502H60.3697C61.7117 130.502 62.4157 130.986 62.4157 131.822ZM64.9531 134H65.8001V125.97H64.9531V134ZM69.4598 134.121C70.4608 134.121 71.1208 133.659 71.5168 133.142V134H72.3308V130.524C72.3308 129.798 72.1328 129.248 71.7478 128.863C71.3298 128.445 70.7138 128.236 69.9108 128.236C69.0858 128.236 68.4698 128.423 67.8428 128.709L68.0958 129.402C68.6238 129.16 69.1518 128.984 69.8228 128.984C70.8898 128.984 71.5168 129.512 71.5168 130.535V130.733C71.0108 130.59 70.4938 130.491 69.7678 130.491C68.3268 130.491 67.3368 131.129 67.3368 132.328V132.35C67.3368 133.516 68.4038 134.121 69.4598 134.121ZM69.6248 133.45C68.8548 133.45 68.1948 133.032 68.1948 132.317V132.295C68.1948 131.58 68.7888 131.118 69.8558 131.118C70.5488 131.118 71.1098 131.239 71.5278 131.36V131.91C71.5278 132.812 70.6698 133.45 69.6248 133.45ZM76.0169 134.11C77.1499 134.11 78.0409 133.483 78.0409 132.405V132.383C78.0409 131.36 77.0949 131.019 76.2149 130.755C75.4559 130.524 74.7519 130.315 74.7519 129.776V129.754C74.7519 129.281 75.1809 128.929 75.8519 128.929C76.4019 128.929 77.0069 129.138 77.5349 129.479L77.9199 128.841C77.3369 128.456 76.5669 128.214 75.8739 128.214C74.7519 128.214 73.9379 128.863 73.9379 129.842V129.864C73.9379 130.909 74.9279 131.217 75.8189 131.47C76.5669 131.679 77.2379 131.899 77.2379 132.471V132.493C77.2379 133.043 76.7429 133.395 76.0609 133.395C75.3899 133.395 74.7079 133.131 74.0919 132.669L73.6629 133.274C74.3009 133.791 75.2029 134.11 76.0169 134.11ZM81.41 134.099C81.817 134.099 82.136 134.011 82.433 133.857V133.131C82.136 133.274 81.894 133.329 81.608 133.329C81.036 133.329 80.651 133.076 80.651 132.383V129.061H82.455V128.313H80.651V126.597H79.804V128.313H79.012V129.061H79.804V132.493C79.804 133.648 80.497 134.099 81.41 134.099Z",
    fill: "#877ADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2746_11537",
    x: 24.4746,
    y: 38.8008,
    width: 89.0977,
    height: 48.1836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_2746_11537"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2746_11537",
    x1: 355820,
    y1: 26948.5,
    x2: 355816,
    y2: 31395.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2746_11537",
    x1: 40.9175,
    y1: 72.8556,
    x2: 43.7311,
    y2: 124.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272054",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlastConnect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blast-connect.1649e161.svg";
export { ForwardRef as ReactComponent };